import 'regenerator-runtime/runtime';
import { put, call, takeEvery, takeLatest,all } from 'redux-saga/effects';
import {
  searchAccounts,
  getById,
  update,
  profilePhoto,
  deleteprofilePhoto,
  resendInvite,
  resetPassword,
  resendConfirmemail,
  remove,
  getByEmail,
  create,
  addUserToClient,
  changePassword,
  suspendUser,
  fetchUsersCloseOption,
  getAllfaq
} from './api';
import * as UserActionType from './constants';
import * as NotifyActionType from '../Notification/constants';

export function* searchUserAsync(action) {

  const result = yield call(searchAccounts, action.payload.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({
      type: UserActionType.SEARCH_SUCCESS,
      data: {
        data: result.data,
        params: action.payload.params
      }
    });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getUserByIdAsync(action) {

  const result = yield call(getById, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({ type: UserActionType.GET_USER_BY_USERID_SUCCESS, data: result.data });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* fetchUsersCloseOptionAsync(action) {

  const result = yield call(fetchUsersCloseOption, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    if (action.callback) { action.callback(result.data); }
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getByEmailAsync(action) {

  const result = yield call(getByEmail, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield put({ type: UserActionType.GET_USER_BY_EMAIL_SUCCESS, data: { item: result.data, searchEmail: action.params } });
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* getAllfaqAsync(action) {

  const result = yield call(getAllfaq, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    if (action.callback){ 
      action.callback(result.data);
     }
    } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}


export function* updateUserAsync(action) {

  const result = yield call(update, action.payload.params.data);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: UserActionType.SEARCH_USER_ASYNC, payload: { params: action.payload.params.search }}),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
    ];
    if (action.payload.callback) {
      action.payload.callback();
    }
  } else {
    yield put({ type: UserActionType.EDIT_USER_ERROR, data: { error: result.data, params: action.payload.params.data} });
    // let error = '';
    // _.map(result.data, (msg) => {
    //   error += `${msg} `;
    // });
    // yield put({ type: NotifyActionType.NOTIFY_ERROR, data: error });
  }
}

export function* updateMyProfileAsync(action) {

  const result = yield call(update, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: UserActionType.UPDATE_MY_PROFILE_SUCCESS, data: action.params }),
    ];

    if (action.callback) { action.callback(result.data); }
  } else {
    // yield put({ type: UserActionType.EDIT_USER_ERROR, data: result.data });
    if (action.callback) { action.callback(result.data); }
    // yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error });
  }
}

export function* updateProfilePhotoAsync(action) {

  const result = yield call(profilePhoto, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: UserActionType.UPDATE_PROFILE_PHOTO_SUCCESS, data: action.params }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Profile Photo Saved' })
    ];

    if (action.callback) { action.callback(result.data); }
  } else {
    // yield put({ type: UserActionType.EDIT_USER_ERROR, data: result.data });
    if (action.callback) { action.callback(result.data); }
    // yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data.error });
  }
}

export function* removeProfilePhotoAsync(action) {
  const result = yield call(deleteprofilePhoto, action.params);
  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: UserActionType.REMOVE_PROFILE_PHOTO_SUCCESS }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Profile Photo Removed' })
    ];
    if (action.callback) { action.callback(result.data); }
  } else {
    if (action.callback) { action.callback(result.data); }
  }
}

export function* inviteNonSystemUserAsync(action) {

  const result = yield call(create, action.params.data);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: UserActionType.INVITE_USER_SUCCESS, data: {} }),
      put({ type: UserActionType.SEARCH_USER_ASYNC, payload: {params: action.params.search }}),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Invitation sent' })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* inviteInSystemUserAsync(action) {

  const result = yield call(addUserToClient, action.params.data);

  const statusCode = result.statusCode;
  if (statusCode === 200) {
    yield [
      put({ type: UserActionType.INVITE_USER_SUCCESS, data: {} }),
      put({ type: UserActionType.SEARCH_USER_ASYNC, payload: {params: action.params.search }}),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Invitation sent' })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* removeUserAsync(action) {

  const result = yield call(remove, action.payload.params.data);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: UserActionType.SEARCH_USER_ASYNC, payload: {params: action.payload.params.search }}),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Deleted' })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* resendInviteAsync(action) {

  const result = yield call(resendInvite, action.payload.params.data);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: UserActionType.SEARCH_USER_ASYNC, payload: {params: action.payload.params.search }}),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Invitation sent' })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* resetPasswordAsync(action) {
  var data = action.payload.params.data;

  const result = yield call(resetPassword, { userId: data.userId, redirectUrl: data.redirectUrl});

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: UserActionType.SEARCH_USER_ASYNC, payload: { params: action.payload.params.search }}),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: data.toastMsg })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* resendConfirmEmailAsync(action) {

  const result = yield call(resendConfirmemail, action.payload.params.data);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: UserActionType.SEARCH_USER_ASYNC, payload: {params: action.payload.params.search }}),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Request sent' })
    ];
  } else {
    yield put({ type: NotifyActionType.NOTIFY_ERROR, data: result.data });
  }
}

export function* changePasswordAsync(action) {

  const result = yield call(changePassword, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: UserActionType.CHANGE_PASSWORD_SUCCESS, data: result.data }),
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Password changed' })
    ];
    if (action.callback) {
      action.callback();
    }
  } else {
    if (action.callback) {
      action.callback(false, result.data);
    }
    yield put({ type: UserActionType.CHANGE_PASSWORD_ERROR, data: result.data });
  }
}

export function* updateLogoCompanyAsync(action) {
  yield [
    put({ type: UserActionType.UPDATE_LOGO_COMPANY_SUCCESS, data: action.data }),
    put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
  ];
  if (action.callback) {
    action.callback();
  }
}
export function* updateHOLogoCompanyAsync(action) {
  yield [
    put({ type: UserActionType.UPDATE_HO_LOGO_COMPANY_SUCCESS, data: action.data }),
    put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Saved' })
  ];
  if (action.callback) {
    action.callback();
  }
}

export function* suspendUserAsync(action) {
  const result = yield call(suspendUser, action.params);

  const statusCode = result.statusCode;

  if (statusCode === 200) {
    yield [
      put({ type: NotifyActionType.NOTIFY_SUCCESS, data: 'Suspended' }),
      put({
        type: UserActionType.SEARCH_USER_ASYNC,
        payload: {
          params: action.params.paramsSearch
        }
      })
    ];

    action.callback(true);
  } else {
    action.callback(false);
  }
}

export default function* WatchUser() {
  yield all([
    takeLatest(UserActionType.SEARCH_USER_ASYNC, searchUserAsync),
    takeLatest(UserActionType.GET_USER_BY_USERID_ASYNC, getUserByIdAsync),
    takeLatest(UserActionType.GET_USER_BY_EMAIL_ASYNC, getByEmailAsync),
    takeEvery(UserActionType.UPDATE_USER_ASYNC, updateUserAsync),
    takeEvery(UserActionType.UPDATE_MY_PROFILE_ASYNC, updateMyProfileAsync),
    takeEvery(UserActionType.UPDATE_PROFILE_PHOTO_ASYNC, updateProfilePhotoAsync),
    takeEvery(UserActionType.REMOVE_PROFILE_PHOTO_ASYNC, removeProfilePhotoAsync),
    takeEvery(UserActionType.INVITE_USER_NON_SYSTEM_ASYNC, inviteNonSystemUserAsync),
    takeEvery(UserActionType.INVITE_USER_IN_SYSTEM_ASYNC, inviteInSystemUserAsync),
    takeEvery(UserActionType.REMOVE_USER_ASYNC, removeUserAsync),
    takeEvery(UserActionType.RESEND_INVITE_ASYNC, resendInviteAsync),
    takeEvery(UserActionType.RESEND_CONFIRM_EMAIL_ASYNC, resendConfirmEmailAsync),
    takeEvery(UserActionType.RESET_PASSWORD_ASYNC, resetPasswordAsync),
    takeEvery(UserActionType.CHANGE_PASSWORD_ASYNC, changePasswordAsync),
    takeLatest(UserActionType.UPDATE_LOGO_COMPANY_ASYNC, updateLogoCompanyAsync),
    takeLatest(UserActionType.UPDATE_HO_LOGO_COMPANY_ASYNC, updateHOLogoCompanyAsync),
    takeLatest(UserActionType.SUSPEND_USER_ASYNC, suspendUserAsync),
    takeLatest(UserActionType.FETCH_USER_CLOSE_OPTION_ASYNC, fetchUsersCloseOptionAsync),
    takeLatest(UserActionType.GET_ALL_FAQ_ASYNC, getAllfaqAsync),
  ]);
}



// WEBPACK FOOTER //
// ./src/User/saga.js